module.exports = ['$scope', 'sessionData', 'services', '$q', 'modal', '$state', 'storage', 'planAdmin', '$http',
	function($scope, sessionData, services, $q, modal, $state, storage, planAdmin, $http) {

		$scope.selectedGroup = {};

		// this method (and this modal) is used in two cases: Change Pcp and View SBC
		$scope.gettingPdf = false;
		$scope.goToChangePcpOrDownloadSbc = function(objSelectedGroup){
			if ($scope.selectedGroup.groupNumber && $scope.umi) {
				storage.set('changePcpSelectedGroupNumber', $scope.selectedGroup.groupNumber);
				sessionData.changePcpSelectedGroup = $scope.selectedGroup.groupNumber;

				// TODO: fire the person who created this chimera
				if($scope.isForSbc) {
					$scope.gettingPdf = true;
					$http.get('https://' + window.location.host + '/eprsvc/x-services/secure/documents/v1/member/' + $scope.umi + '/' + $scope.selectedGroup.groupNumber + '/summary-of-benefits').then(
						function (response) {
							console.error('ERROR: we got an unexpected response from the http get.');
						},
						function (error) {
							if (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription === 'DOCUMENTS-NOT-FOUND') {
								$scope.gettingPdf = false;
								if (sessionData.employerInfo.brandName == 6008) {
									$scope.viewstate = 'no-ibc-sbc-pdf';
								}
								if (sessionData.employerInfo.brandName == 6009) {
									$scope.viewstate = 'no-ahnj-sbc-pdf';
								}
							}
							else if (error && error.message) {
								// you got the pdf file, and angular cant parse it so it throws this error, so now we download it
								// There is probably an angular option to pass to the $http.get to handle this better but I couldn't figure that out within the available time
								window.location.href = 'https://' + window.location.host + '/eprsvc/x-services/secure/documents/v1/member/' +
									$scope.umi + '/' + $scope.selectedGroup.groupNumber + '/summary-of-benefits';
								setTimeout(function() {
									$scope.gettingPdf = false;
									modal.close();
								}, 3000);
							}
							else {
								$scope.gettingPdf = false;
								$scope.viewstate = 'error';
							}
						}
					);
				}
				else {
					// we are doing the Change PCP thing
					sessionData.isIbcAhpa = false;
					if (sessionData.employerInfo.brandName == '6008' && objSelectedGroup.planAreaCode && objSelectedGroup.planAreaCode == '375') {
						sessionData.isIbcAhpa = true;
					}
					modal.close();
					$state.go('assistEmployees.changePcp',
						{
							groupNumber: $scope.selectedGroup.groupNumber,
							umi: $scope.umi
						} ); }
			}
		};

		$scope.topLabel = ($scope.isForSbc) ? 'View SBC for this Group' : 'Change PCP for this Group';

		if ($scope.isForSbc || planAdmin.canModifyGroupNumber($scope.groupNumber)) {
			findTheGroups($scope.activeGroupNumbers);
		}
		else {
			$scope.viewstate = 'no-permission';
		}

		function findTheGroups(activeGroupNumbers) {
			if (!activeGroupNumbers.length) {
				$scope.viewstate = 'no-active-groups';
				return;
			}

			var agiPromises = activeGroupNumbers.reduce(
				function(prev, next) {
					prev[next] = services.eprsvc.additionalGroupInformation({ 'groupNumber': next }).fetch(services.eprsvc.additionalGroupInformation().getEffectiveDate(next));
					return prev;
				},
				{}
			);

			$scope.viewstate = 'loading';

			$q.all(agiPromises).then(
				function(response){
					$scope.viewstate = 'success';

					$scope.groupNumbersWithPlanAreaCode = Object.keys(response).map(
						function(groupNumber) {
							var planAreaCode =
								response[groupNumber] &&
								response[groupNumber].data &&
								response[groupNumber].data.payload &&
								response[groupNumber].data.payload.planAreaCode;

							return {
								groupNumber: groupNumber,
								planAreaCode: planAreaCode
							};
						}
					).filter(function(g) { return g.planAreaCode; }).map(function(g) { return g.groupNumber; });
				},
				function() { $scope.viewstate = 'error'; }
			);
		}
	}
];
